import { __assign, __makeTemplateObject, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, keyframes } from "@mui/material/styles";
import MoaStyledComponent from "../../Style/MoaStyled";
import { MarginProps } from "../../Style/Margin";
import { PaddingProps } from "../../Style/Padding";
import { Stack, Color } from "../..";
import CircularProgress, { circularProgressClasses } from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
var getItemDirection = function (props) {
    if (props.column) {
        return { condition: true, value: 'column' };
    }
    else if (props.row) {
        return { condition: true, value: 'row' };
    }
    else if (props.rowReverse) {
        return { condition: true, value: 'row-reverse' };
    }
    else if (props.columnReverse) {
        return { condition: true, value: 'column-reverse' };
    }
    else {
        return { condition: false, value: 'column' };
    }
};
var getItemHorizontalAlign = function (props) {
    if (props.center) {
        return { condition: true, value: 'center' };
    }
    else if (props.horLeft) {
        return { condition: true, value: 'flex-start' };
    }
    else if (props.horCenter) {
        return { condition: true, value: 'center' };
    }
    else if (props.horRight) {
        return { condition: true, value: 'flex-end' };
    }
    else if (props.horSpaceBetween) {
        return { condition: true, value: 'space-between' };
    }
    else {
        return { condition: false, value: 'flex-start' };
    }
};
var getItemVerticalAlign = function (props) {
    if (props.center) {
        return { condition: true, value: 'center' };
    }
    else if (props.verTop) {
        return { condition: true, value: 'flex-start' };
    }
    else if (props.verCenter) {
        return { condition: true, value: 'center' };
    }
    else if (props.verBottom) {
        return { condition: true, value: 'flex-end' };
    }
    else if (props.verSpaceBetween) {
        return { condition: true, value: 'space-between' };
    }
    else {
        return { condition: false, value: 'flex-start' };
    }
};
export var fillColor = function (show, fill) {
    if (!show) {
        return "transparent";
    }
    else if (fill) {
        if (fill === '0') {
            return 'rgba(240, 240, 240, 0.5)';
        }
        else if (fill === '1') {
            return 'rgba(210, 210, 210, 0.5)';
        }
        else if (fill === '2') {
            return 'rgba(180, 180, 180, 0.5)';
        }
        else if (fill === '3') {
            return 'rgba(150, 150, 150, 0.5)';
        }
        else if (fill === '4') {
            return 'rgba(120, 120, 120, 0.5)';
        }
        else if (fill === '5') {
            return 'rgba(90, 90, 90, 0.5)';
        }
        else if (fill === '6') {
            return 'rgba(60, 60, 60, 0.5)';
        }
        else if (fill === '7') {
            return 'rgba(30, 30, 30, 0.5)';
        }
        else if (fill === '8') {
            return 'rgba(0, 0, 0, 0.5)';
        }
        else {
            return fill;
        }
    }
    else {
        return "rgba(240, 240, 240, 0.5)";
    }
};
// keyframes 정의
var kf_pulse = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0%, 100% {\n    transform: scale(0.99);\n    opacity: 0.8;\n  }\n  50% {\n    transform: scale(1);\n    opacity: 0.5;\n  }\n"], ["\n  0%, 100% {\n    transform: scale(0.99);\n    opacity: 0.8;\n  }\n  50% {\n    transform: scale(1);\n    opacity: 0.5;\n  }\n"])));
var kf_transition = keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  0%, 100% {\n    opacity: 0.8;\n  }\n  50% {\n    opacity: 0.5;\n  }\n"], ["\n  0%, 100% {\n    opacity: 0.8;\n  }\n  50% {\n    opacity: 0.5;\n  }\n"])));
function CustomCircularloading(_a) {
    var _b;
    var color = _a.color;
    return (_jsxs(Box, { sx: { position: 'relative', display: 'flex', opacity: 0.3 }, children: [_jsx(CircularProgress, { variant: "determinate", sx: {
                    // color: (theme) => theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
                    color: color === "negative" ? '#1F2327' : Color.primary.enable,
                }, size: 30, thickness: 4, value: 100 }), _jsx(CircularProgress, { variant: "indeterminate", disableShrink: true, sx: (_b = {
                        // color: (theme) => (theme.palette.mode === 'light' ? Color.primary.enable_strock : '#308fe8'),
                        color: color === "negative" ? Color.primaryNegative.white : Color.primary.enable_strock,
                        animationDuration: '550ms',
                        position: 'absolute',
                        left: 0
                    },
                    _b["& .".concat(circularProgressClasses.circle)] = {
                        strokeLinecap: 'round',
                    },
                    _b), size: 30, thickness: 4 })] }));
}
// Loading button styles
var loadingStackStyles = {
    position: 'relative', // Make sure it's above the other elements
};
var loadingStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 2,
    marginTop: 0, // Reset margin because of stack spacing value
};
var GuideBox = function (props) {
    var id = props.id, children = props.children, show = props.show, width = props.width, height = props.height, fill = props.fill, 
    // column, 
    // row, 
    // rowReverse,
    // columnReverse,
    spacing = props.spacing, 
    // center, 
    // horLeft, 
    // horCenter, 
    // horRight, 
    // horSpaceBetween, 
    // verTop, 
    // verCenter, 
    // verBottom,
    // verSpaceBetween,
    // padding, paddingX, paddingY, paddingTop, paddingBottom, paddingLeft, paddingRight,
    // margin, marginX, marginY, marginTop, marginBottom, marginLeft, marginRight, 
    opacity = props.opacity, duration = props.duration, pulse = props.pulse, loading = props.loading, overflow = props.overflow, borderRadius = props.borderRadius, border = props.border, flexGrow = props.flexGrow, onKeyDown = props.onKeyDown, rest = __rest(props, ["id", "children", "show", "width", "height", "fill", "spacing", "opacity", "duration", "pulse", "loading", "overflow", "borderRadius", "border", "flexGrow", "onKeyDown"]);
    return (_jsxs(Stack, __assign({ id: id, width: width, height: height }, rest, { sx: __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, MarginProps(props)), PaddingProps(props)), { backgroundColor: fillColor(show, fill), opacity: opacity, boxSizing: 'border-box' }), (pulse ? { animation: "".concat(kf_pulse, " ").concat(duration, "s infinite") } : {})), (loading ? loadingStackStyles : {})), (loading ? { animation: "".concat(kf_transition, " ").concat(duration, "s infinite") } : {})), (borderRadius ? { borderRadius: borderRadius } : {})), (border ? { border: border } : {})), overflow: overflow || "visible", direction: getItemDirection(props).value, spacing: spacing, display: "flex", justifyContent: getItemDirection(props).value === 'row' ? getItemHorizontalAlign(props).value : getItemVerticalAlign(props).value, alignItems: getItemDirection(props).value === 'row' ? getItemVerticalAlign(props).value : getItemHorizontalAlign(props).value, flexGrow: flexGrow || undefined, onKeyDown: onKeyDown || undefined, children: [children, loading && (_jsx("div", { style: __assign({}, loadingStyles), children: _jsx(CustomCircularloading, { color: "negative" }) }))] })));
};
var StyledComponent = styled(function (props) {
    return _jsx(GuideBox, __assign({}, props));
})(function () { return ({}); });
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
var templateObject_1, templateObject_2;
